import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubPulsarsDiscoveryStrategicContentSectionHeaderCls: string;
			heHubPulsarsDiscoveryStrategicContentSectionTextCls: string;
		}
	},

	slug: string
}

class Strategic extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub Pulsars Discovery Strategic Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryStrategicContentSectionHeaderCls || '', 'he_hub_pulsars_discovery_strategic', { animCls: 'animate__fadeInDown50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryStrategicContentSectionTextCls || '', 'he_hub_pulsars_discovery_strategic', { animCls: 'animate__fadeInUp50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Strategic;